const SearchTextUtil = (function() {
    /**
     * bindSearchTextField : binding text fields
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param event object
     * @param defaultConfig object
     */
    const bindSearchTextField = (event, defaultConfig = {}) => {
        let input, filter, table, tr, td, i, txtValue;
        input = defaultConfig.analyserTransactionsTableDataSearchText[0];
        filter = input.value.toUpperCase();
        table = initScript.getHTMLElementByDelimiter(defaultConfig.activatedTAB + '_' + defaultConfig.classNames.table + ' tbody')[0];
        tr = table.getElementsByTagName("tr");
        const headers = Object.keys(defaultConfig.dp[0][0]);
        for (i = 1; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td");
            let flag = false;
            for (let j = 0; j < headers.length; ++j) {
                txtValue = td[j].textContent || td[j].innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    flag = true;
                    break;
                }
            }
            if (flag) tr[i].style.display = "";
            else tr[i].style.display = "none";
        }
    };
    return {
        bindSearchTextField
    };
})();
